import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IEntubaRequest } from '../interface/entuba/IEntubaRequest';
import { ICreateTradeWholesaleBatch } from '../interface/Wholesale/ICreateTradeWholesaleBatch';

enum PrecatorioWholeSaleServiceEnum {
  base = "/",
  start = "/start",
  reprocess = "/reprocess",
  getDetail = ""
}

export default class PrecatorioWholeSaleService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/wholesale/entuba");
  }

  public start = async (data: IEntubaRequest) => await this.POST(PrecatorioWholeSaleServiceEnum.start, data);
  public reprocess = async (data: IEntubaRequest) => await this.POST(PrecatorioWholeSaleServiceEnum.reprocess, data);
  public getAll = async (): Promise<ICreateTradeWholesaleBatch[]> => await this.GET(PrecatorioWholeSaleServiceEnum.base);
  public getDetail = async idBatch => {
    const data = await this.GET(`${PrecatorioWholeSaleServiceEnum.getDetail}/${idBatch}`);
    return data;
  };

}